import { Component } from "react"

/**
 * Isola falha de render do saldo para não derrubar o restante do app.
 * Sem fallback customizado, some em silêncio (útil na home).
 */
export default class SaldoHomeBoundary extends Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError() {
		return { hasError: true }
	}

	componentDidCatch(error, errorInfo) {
		console.error("[Saldo] erro isolado:", error, errorInfo)
	}

	render() {
		if (this.state.hasError) {
			return this.props.fallback ?? null
		}
		return this.props.children
	}
}
